import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as selectors from '../../selectors/authentication';
import { inputChangePassword, submitChangePassword } from '../../actions/authentication';
import { bindActionCreators } from 'redux';
import ChangePasswordForm from '../../components/application/authentication/ChangePasswordForm';

class ChangePassword extends Component {
    _onSubmit = () => this.props.submitChangePassword(this.props.oldPassword, this.props.newPassword);
    render() {
        return (
            <ChangePasswordForm
                canSubmit={this.props.canSubmit}
                loading={this.props.loading}
                newPassword={this.props.newPassword}
                newPasswordConfirmation={this.props.newPasswordConfirmation}
                newPasswordConfirmationError={this.props.newPasswordConfirmationError}
                newPasswordError={this.props.newPasswordError}
                oldPassword={this.props.oldPassword}
                oldPasswordError={this.props.oldPasswordError}
                onInput={this.props.inputChangePassword}
                onSubmit={this._onSubmit}
            />
        );
    }
}

const mapStateToProps = state => ({
    email: selectors.emailSelector(state),
    loading: selectors.isSubmittingSelector(state),
    canSubmit: selectors.canSubmitChangePassword(state),
    oldPassword: selectors.oldPasswordSelector(state),
    newPassword: selectors.newPasswordSelector(state),
    newPasswordConfirmation: selectors.newPasswordConfirmationSelector(state),
    newPasswordError: selectors.newPasswordError(state),
    newPasswordConfirmationError: selectors.newPasswordConfirmationError(state),
    oldPasswordError: selectors.errorSelector(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({ inputChangePassword, submitChangePassword }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);



// WEBPACK FOOTER //
// ./src/containers/authentication/ChangePassword.js